// Idle-time prefetch of the most-visited route chunks (iter 1059).
// Webpack dedupes dynamic imports by path, so React.lazy resolves instantly
// from the already-loaded chunk - navigation feels immediate instead of
// showing a skeleton while the chunk downloads.
let prefetched = false;

export function prefetchCoreRoutes() {
  if (prefetched) return;
  prefetched = true;

  const load = () => {
    const routes = [
      () => import('./pages/DashboardPage'),
      () => import('./pages/InvoicesPage'),
      () => import('./pages/BillsPage'),
      () => import('./pages/InsightsPage'),
      () => import('./pages/AkountFlyAIPage'),
      () => import('./pages/BankFeedCenterPage'),
      () => import('./pages/MyBanksPage'),
      () => import('./pages/ReportsPage'),
      () => import('./pages/BudgetPage'),
      () => import('./pages/ProductsServicesPage'),
      () => import('./pages/AdvancedViewPage'),
      () => import('./pages/SettingsPage'),
      () => import('./pages/CreateInvoicePage'),
      () => import('./pages/CreateBillPage'),
      () => import('./pages/InvoiceDetailPage'),
      () => import('./pages/TransactionReviewPage'),
    ];
    // Stagger imports so we never contend with in-flight user requests
    routes.forEach((imp, i) => setTimeout(() => imp().catch(() => {}), i * 250));
  };

  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(load, { timeout: 4000 });
  } else {
    setTimeout(load, 2500);
  }
}
